(<template>
  <div class="form">
    <h1 v-translate>Edit profile</h1>
    <div class="profile">
      <img class="profile-image" :src="avatarUrl()"/><br />
      <strong>{{this.$session.get('username')}}</strong>
    </div>
    <el-form :model="userForm"
             :rules="rules"
             ref="userForm"
             label-position="left"
             label-width="12em">
      <el-form-item>
        <span slot="label" v-translate>Email</span>
        <el-input :disabled="true" type="email" v-model="userForm.email"></el-input>
      </el-form-item>
      <el-form-item prop="firstName">
        <span slot="label" v-translate>First name</span>
        <el-input v-model="userForm.firstName" prop="firstName"></el-input>
      </el-form-item>
      <el-form-item prop="lastName">
        <span slot="label" v-translate>Last name</span>
        <el-input v-model="userForm.lastName" prop="lastName"></el-input>
      </el-form-item>
      <el-form-item prop="phoneNumber">
        <span slot="label" v-translate>Phone number</span>
        <el-input v-model="userForm.phoneNumber" prop="phoneNumber"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <span slot="label" v-translate>Change password</span>
        <el-input :type="password.type" v-model="password.value">
          <el-button slot="append" :icon="password.icon" @click="showPassword"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item>
        <span slot="label" v-translate>Role</span>
        <el-input :disabled="true" v-model="userForm.role"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">
          <span v-translate>Update</span>
        </el-button>
        <el-button type="warning" @click="resetForm">
          <span v-translate>Reset</span>
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>)

(<script>
import axios from 'axios'
import md5 from 'md5'

export default {
  name: 'update-profile',
  data () {
    return {
      password: {
        visible: false,
        type: 'password',
        icon: 'el-icon-fa-eye',
        value: ''
      },
      userForm: {},
      rules: {
        firstName: {
          type: 'string',
          required: false
        },
        lastName: {
          type: 'string',
          required: false
        },
        password: [
          {
            type: 'string',
            required: false
          }, {
            min: 5,
            message: this.$gettext('Length should be min 5 characters'),
            trigger: 'blur'
          }
        ],
        phoneNumber: [
          {
            type: 'string',
            required: false
          },
          {
            validator: this.validatePhoneNumber,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$session.exists()) {
        next()
      } else {
        next('/signin')
      }
    })
  },
  created () {
    this.getUserDetails()
  },
  methods: {
    validatePhoneNumber (rule, value, callback) {
      if (value !== '') {
        var regex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/
        if (regex.test(value)) {
          callback()
        } else {
          callback(new Error(this.$gettext('Phone number is not valid')))
        }
      } else {
        callback()
      }
    },
    avatarUrl () {
      return `https://www.gravatar.com/avatar/${md5(this.$session.get('email').trim().toLowerCase())}?s=200`
    },
    showPassword () {
      if (!this.password.visible) {
        this.password.type = 'text'
        this.password.icon = 'el-icon-fa-eye-slash'
        this.password.visible = true
      } else {
        this.password.type = 'password'
        this.password.icon = 'el-icon-fa-eye'
        this.password.visible = false
      }
    },
    getUserDetails () {
      axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/users/${this.$session.get('id')}`,
        withCredentials: true
      })
      .then(response => {
        this.userForm = response.data
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    uploadForm () {
      axios({
        method: 'put',
        url: `${process.env.SERVER_URL}/users/${this.$session.get('id')}`,
        withCredentials: true,
        headers: {'Content-Type': 'application/json'},
        data: {
          firstName: this.userForm.firstName,
          lastName: this.userForm.lastName,
          password: this.password.value,
          phoneNumber: this.userForm.phoneNumber
        }
      })
      .then(() => {
        this.$message({
          type: 'success',
          message: this.$gettext('Update has completed')
        })
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    submitForm () {
      this.$refs['userForm'].validate(valid => {
        if (valid) {
          this.uploadForm()
        }
      })
    },
    resetForm () {
      this.getUserDetails()
      this.password.value = ''
    }
  }
}
</script>)

(<style>
.profile {
  padding: 2%;
  height: 5%;
  text-decoration: underline;
}
.profile-image {
  height: 100%;
  margin: auto;
  border-radius: 50%;
  border: solid 1px grey;
}
</style>)



// WEBPACK FOOTER //
// src/components/Update-Profile-Form.vue